// extracted by mini-css-extract-plugin
module.exports = {"WrapperFeaturedShortmessagesHighlightsAds":"yRZ2","InnerFeaturedShortmessagesHighlights":"_7loD","InnerAds":"YUdM"};